import { useState } from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { styled } from '@mui/material/styles';
import Button from '@components/Button';
import TextEditor from '@components/TextEditor';
import { parseTipTapJSONToPlainText } from '@helpers/text-editor';
import { useTranslation } from '@hooks';
import { SendIcon } from 'assets/images/icons';

const StyledTextEditor = styled(TextEditor)({
    paddingBottom: ' 0 !important',
    backgroundColor: '#fff',
    '& .ProseMirror': {
        maxHeight: '48px !important',
        minHeight: 'auto !important',
    },
    '& .editor-container': {
        display: 'grid',
        gridTemplateColumns: 'minmax(auto, calc(100% - 46px)) 38px',
        gridGap: '8px',
        alignItems: 'flex-end',
        padding: '11px',
        minHeight: 'auto',
        '&:focus-within': {
            padding: '10px !important',
        },
    },
    '& .editor-toolbar': {
        bottom: '50% !important',
        right: '12px !important',
        width: 'auto !important',
        left: 'auto !important',
        transform: 'translateY(50%) !important',
    },
});

const StyledButton = styled(Button)({
    height: 22,
    minWidth: 'auto',
    '& .MuiButton-endIcon': {
        margin: 0,
    },
});

const SendButton = ({ disabled, onClick }) => {
    const { editor } = useCurrentEditor();

    return (
        <StyledButton variant="contained" disabled={disabled} onClick={() => onClick(editor)} endIcon={<SendIcon />} />
    );
};

const PulseAIInput = ({ onSend, isTyping }) => {
    const [message, setMessage] = useState('');

    const { t } = useTranslation();

    const onClickSendMessage = async editor => {
        const parsedMessage = parseTipTapJSONToPlainText(message);
        editor?.commands.clearContent(false);
        setMessage('');
        await onSend(parsedMessage);
    };

    return (
        <StyledTextEditor
            initialValue={''}
            onChange={text => setMessage(text)}
            editable={!isTyping}
            containerProps={{
                onKeyDown: async (e, editor) => {
                    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
                        if (!isTyping && message) {
                            await onClickSendMessage(editor);
                        }
                    }
                },
            }}
            placeholder={t('InboxPage.messageLabel')}
            toolbar={<SendButton disabled={isTyping || !message} onClick={onClickSendMessage} />}
        />
    );
};

export default PulseAIInput;
